import React from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';

// import { Container } from './styles';

const Cursos: React.FC = () => {
	return (
		<>
			<Breadcrumb>
				<Breadcrumb.Item>
					<HomeOutlined />
					<span>Home</span>
				</Breadcrumb.Item>
				<Breadcrumb.Item>Cursos</Breadcrumb.Item>
				<Breadcrumb.Item>Listar</Breadcrumb.Item>
			</Breadcrumb>
			<h1>Cursos</h1>
		</>
	);
};

export default Cursos;
